import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import { AppCard, AppNoInfo } from '@/layout/AppComponents';
import { axiosPath } from '../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import useIsMounted from '../../../../components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';
import Translator from '../../../../components/helpers/Translator';
import AppLink from '../../../../../routing/helpers/AppLink';
import { getPeriodOptions, getRiskLevelOptions } from '../tools/riskManagerTools';

export default function IdentificationTab({ elementID }) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const resLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1?.[elementID]
  );
  const identification = useSelector(
    (s) => s.currentPage?.identificationTab?.[elementID]
  );
  const permissionLevel = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.userBridge?.permissions?.level
  );
  const [isLoading, setIsLoading] = useState(true);

  // > LOAD IDENTIFICATION TAB
  const loadIdentification = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            "api_r_user_module_inecoRiskManager_risk_identification_tab"
          ),
          { moduleBridgeHex, riskID: elementID }
        )
        .then(({ data }) => {
          if (isMounted.current) {
            dispatch(
              currentPageAction.change(
                "identificationTab",
                {
                  [elementID]: data,
                },
                true
              )
            );
          }
        })
        .catch((e) => dispatch(errorHandler(e)))
        .finally(() => setIsLoading(false)),
    [moduleBridgeHex, elementID]
  );

  useEffect(() => {
    if (isLoading) loadIdentification();
  }, [isLoading]);
  // < LOAD IDENTIFICATION TAB

  if (isLoading) return <AppNoInfo minHeight={300} />;

  return (
    <div className="container-fluid">
      <div className="row mt-3">
        {/* {permissions?.fields?.category && (
          <div className="col-lg-6 mb-3">
            <AppCard header="Categoría" headerClassName="text-white bg-primary">
              <CardBlock>{resLevel1?.category?.name}</CardBlock>
            </AppCard>
          </div>
        )} */}
        <div className="col-lg-6 mb-3">
          <AppCard
            header="Causa (debido a)"
            headerClassName="text-white bg-primary"
          >
            <CardBlock>{resLevel1?.cause}</CardBlock>
          </AppCard>
        </div>
        <div className="col-lg-6 mb-3">
          <AppCard
            header="Evento (se puede producir)"
            headerClassName="text-white bg-primary"
          >
            <CardBlock>{resLevel1?.event}</CardBlock>
          </AppCard>
        </div>
        <div className="col-lg-6 mb-3">
          <AppCard
            header="Efecto (por lo que)"
            headerClassName="text-white bg-primary"
            className="h-10"
          >
            <CardBlock>{resLevel1?.effect}</CardBlock>
          </AppCard>
        </div>
        <div className="col-lg-6 mb-3">
          <AppCard
            header="Objetivo estratégico"
            headerClassName="text-white bg-primary"
          >
            <CardBlock>{resLevel1?.strategicGoal?.name}</CardBlock>
          </AppCard>
        </div>
        <div className="col-lg-6 mb-3">
          <AppCard
            header="Acciones Realizadas"
            headerClassName="text-white bg-primary"
          >
            <CardBlock>{identification?.actionPlanText}</CardBlock>
          </AppCard>
        </div>
        <div className="col-lg-6 mb-3">
          <AppCard header="Indicador" headerClassName="text-white bg-primary">
            <CardBlock>{identification?.indicator}</CardBlock>
          </AppCard>
        </div>
        <div className="col-lg-6 mb-3">
          <AppCard header="Fecha" headerClassName="text-white bg-primary">
            <CardBlock>{identification?.date}</CardBlock>
          </AppCard>
        </div>
        <div className="col-lg-6 mb-3">
          <AppCard header="Plazo" headerClassName="text-white bg-primary">
            <CardBlock>{getPeriodOptions()?.find((p) => p?.value === identification?.period)?.label}</CardBlock>
          </AppCard>
        </div>
        <div className="col-lg-6 mb-3">
          <AppCard header="Nivel de Riesgo" headerClassName="text-white bg-primary">
            <CardBlock>{getRiskLevelOptions()?.find((rl) => rl?.value === identification?.riskLevel)?.label}</CardBlock>
          </AppCard>
        </div>
        <div className="col-lg-6 mb-3">
          <AppCard header="Procesos de la organizacións" headerClassName="text-white bg-primary">
            <CardBlock>{identification?.organizationProcesses?.length > 0 ? <ul>{identification?.organizationProcesses?.map((op) => <li>{op.name}</li>)}</ul> : <></>}</CardBlock>
          </AppCard>
        </div>
      </div>
      {permissionLevel === 0 && (
        <div className="row">
          <div className="col-12">
            <AppLink
              path="user_module_inecoRiskManager_risk_home"
              params={{
                moduleBridgeHex,
                riskID: resLevel1?.id,
              }}
              title="Editar"
              className="btn btn-sm btn-success"
            >
              Editar
            </AppLink>
          </div>
        </div>
      )}
    </div>
  );
}

const CardBlock = styled.div`
  min-height: 60px;
`;
